import CryptoJS from 'crypto-js';

export const hashPassword = (password) => {
  const ik = CryptoJS.PBKDF2(password, '', {
    keySize: 32,
    iterations: 1024,
    hasher: CryptoJS.algo.SHA256,
  });
  return ik.toString(CryptoJS.enc.Hex).substring(0, 64);
};
